import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { setTagsScopeFilter } from "../../appRedux/actions/tags";

const BASE_SCOPES = [
  { key: "all", label: "All Scopes", icon: "la la-globe" },
  { key: "platform", label: "Platform", icon: "la la-server" },
  { key: "skill", label: "Skill", icon: "la la-code" },
  { key: "course", label: "Course", icon: "la la-graduation-cap" },
  { key: "product", label: "Product", icon: "la la-shopping-bag" },
  { key: "deal", label: "Deal / Offer", icon: "la la-fire" },
  { key: "blog", label: "Blog", icon: "la la-newspaper-o" },
  { key: "category", label: "Category", icon: "la la-th-large" },
  { key: "global", label: "Global", icon: "la la-compass" },
];

export default function ScopeTabs() {
  const dispatch = useDispatch();
  const selectedScope = useSelector((state) => state.tags?.selectedScope || "all");
  const tagsList = useSelector((state) => state.tags?.tagsList || []);

  const getCount = (scopeKey) => {
    if (scopeKey === "all") return tagsList.length;
    return tagsList.filter((tag) => (tag.scope || "global").toLowerCase() === scopeKey).length;
  };

  // Collect any custom scope present in DB tags not in base scopes
  const extraScopes = Array.from(
    new Set(tagsList.map((t) => (t.scope || "global").toLowerCase()))
  )
    .filter((s) => !BASE_SCOPES.some((b) => b.key === s))
    .map((s) => ({
      key: s,
      label: s.charAt(0).toUpperCase() + s.slice(1),
      icon: "la la-tag",
    }));

  const allScopesToRender = [...BASE_SCOPES, ...extraScopes];

  return (
    <div className="mb-3">
      <div
        className="d-flex align-items-center gap-2 overflow-auto py-1"
        style={{
          whiteSpace: "nowrap",
          scrollbarWidth: "thin",
        }}
      >
        {allScopesToRender.map((scope) => {
          const isActive = selectedScope === scope.key;
          const count = getCount(scope.key);
          return (
            <button
              key={scope.key}
              onClick={() => dispatch(setTagsScopeFilter(scope.key))}
              className={`btn btn-sm d-flex align-items-center gap-2 ${
                isActive ? "btn-primary shadow-sm" : "btn-outline-secondary bg-white"
              }`}
              style={{
                borderRadius: "20px",
                padding: "6px 14px",
                fontWeight: isActive ? "600" : "500",
                transition: "all 0.2s ease",
              }}
            >
              <i className={scope.icon} style={{ fontSize: "15px" }} />
              <span>{scope.label}</span>
              <span
                className={`badge rounded-pill ${
                  isActive ? "bg-white text-primary" : "bg-light text-dark border"
                }`}
                style={{ fontSize: "11px", fontWeight: "600" }}
              >
                {count}
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
